import { createFileRoute } from "@tanstack/react-router";

import { DashboardShell } from "@/components/dashboard-shell";
import { CompetitorsPage } from "@/components/competitors/competitors-page";
import { CardGridSkeleton, RouteLoading, ToolbarSkeleton } from "@/components/route-loading";

export const Route = createFileRoute("/competitors/")({
  component: CompetitorsRoute,
  head: () => ({ meta: [{ title: "Competitors" }] }),
  pendingComponent: CompetitorsPending,
});

function CompetitorsRoute() {
  return (
    <DashboardShell>
      <CompetitorsPage />
    </DashboardShell>
  );
}

function CompetitorsPending() {
  return (
    <RouteLoading>
      <ToolbarSkeleton />
      <CardGridSkeleton />
    </RouteLoading>
  );
}
